import * as z from "zod/v4";

const TrackingEventResultSchema_ = z.object({
  datetime: z.date(),
  message: z.string(),
  location: z.string().nullish(),
});

export const TrackingEventResultSchema: z.ZodType<TrackingEventResult> =
  TrackingEventResultSchema_;

export interface TrackingEventResult
  extends z.infer<typeof TrackingEventResultSchema_> {}

const TrackingLookupResultSchema_ = z.object({
  success: z.boolean(),
  error: z.string().nullish(),
  providerId: z.string().nullish(),
  trackingPlatform: z.string().nullish(),
  resolvedCarrier: z.string().nullish(),
  rawCarrier: z.string().nullish(),
  status: z.string().nullish(),
  statusDetail: z.string().nullish(),
  estimatedDeliveryDateLocal: z.string().nullish(),
  publicUrl: z.string().nullish(),
  events: z.array(TrackingEventResultSchema).nullish(),
  /** True if primary provider failed and fallback was used */
  usedFallback: z.boolean().nullish(),
  /** Error message from the primary provider if fallback was used */
  primaryError: z.string().nullish(),
});

export const TrackingLookupResultSchema: z.ZodType<TrackingLookupResult> =
  TrackingLookupResultSchema_;

export interface TrackingLookupResult
  extends z.infer<typeof TrackingLookupResultSchema_> {}

export const LookupTrackingInputSchema = z.object({
  trackingCode: z.string(),
  carrier: z.string().optional(),
  teamId: z.string().optional(),
});

export type LookupTrackingInput = z.infer<typeof LookupTrackingInputSchema>;
export type LookupTrackingOutput = TrackingLookupResult;

export const lookupTracking = {
  name: "lookupTracking" as const,
  input: LookupTrackingInputSchema,
  output: TrackingLookupResultSchema,
};
